import React, { Component, ErrorInfo } from 'react'
import { Flex } from 'antd-mobile'

interface ErrorBoundaryProps {}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error: Error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // 本地打印错误
    console.group()
    console.log('ErrorBoundary catch a error:')
    console.info('error', error)
    console.info('error info', errorInfo)
    console.groupEnd()

    // 将错误信息上报给性能监控平台
    let { message, stack = '' } = error
    let resourceUrl: any,
      col: number = 1,
      line: number = 1
    let errs: any = stack.match(/\(.+?\)/)
    if (errs && errs.length) {
      errs = errs[0]
    }
    errs = errs.replace(/\w.+js/g, ($1: any) => {
      resourceUrl = $1
      return ''
    })
    errs = errs.split(':')
    if (errs && errs.length > 1) {
      line = parseInt(errs[1] || 0)
    }
    col = parseInt(errs[2] || 0)
    // @ts-ignore
    window.Performance.addError({
      msg: message,
      col: col,
      line: line,
      resourceUrl: resourceUrl,
    })
  }

  render() {
    const { children } = this.props
    const { hasError } = this.state
    if (hasError) {
      return (
        <Flex justify="center" align="center" style={{ height: '100%' }}>
          <span
            style={{
              padding: '10px 20px',
              backgroundColor: '#fff',
              borderRadius: 6
            }}
            className="text-sm color-orange"
          >
            初始化出错，请联系Aiwan SDK支持人员
          </span>
        </Flex>
      )
    }
    return children
  }
}

export default ErrorBoundary
